<div class="container-section">
  <div class="iata-section">
    {{ 'itinerary-info.passengers-info.iata-code' | translate }}: {{ iataNumberCode }}
  </div>
  <div class="ticket-section">
    <div *ngFor="let segment of ticketSegments; index as i">
      <!-- Segment Header: Ida/Vuelta - Tramo -->
      <div>
        <div class="is-uppercase is-size-1em" *ngIf="!isMultidestiny; else multidestiny">
          <em
            [class.rotate-270]="i % 2 !== 0"
            class="mdi mdi-airplane mdi-16px mdi-rotate-90 align"
            aria-hidden="true"
          ></em>

          <span *ngIf="i === 0"> {{ 'itinerary-info.passengers-info.departing' | translate }}</span>
          <span *ngIf="i !== 0">
            {{ 'itinerary-info.passengers-info.returning' | translate }}
          </span>
        </div>

        <ng-template #multidestiny>
          <div class="is-uppercase weight-medium pb-1">
            <em class="mdi mdi-airplane mdi-16px mdi-rotate-90 align" aria-hidden="true"></em>
            <span> {{ 'itinerary-info.segments-info.segment' | translate }}</span> {{ i + 1 }}
          </div>
        </ng-template>
        <!-- Segments -->
        <ul class="is-marginless pb-1 pl-custom" *ngFor="let flight of segment.flights">
          <li *ngIf="flight?.ticketStatus != 'arunk'">
            <div class="is-capitalized weight-medium">
              {{ flight?.departure?.name | lowercase }} ({{ flight?.departure?.code }}) -
              {{ flight?.arrival?.name | lowercase }} ({{ flight?.arrival?.code }})
            </div>
            <div class="pl-1 pb-1">
              <div>
                <span *ngIf="flight.isNoShow" class="tag is-dark">No Show</span>
              </div>

              <div class="is-block is-capitalized">
                {{ flight?.ticketStatus | uppercase }} •
                {{ 'itinerary-info.flight.class' | translate | lowercase }}:
                {{ flight?.classOfService }} •
                {{ 'itinerary-info.flight.flight' | translate | lowercase }}: {{ flight?.numberFlightValidatingCarrier }}
              </div>
              <div attr.data-title="{{ flight.departureDateTime }}">
                {{ flight.departureDateTime | date | localizedDate : 'EEE d MMM y ' : '+0000' }} •
                {{ flight.departureDateTime | date : 'HH:mm' }}
              </div>

              <div *ngIf="isAirline">
                <em class="mdi mdi-briefcase mdi-12px"></em>
                {{
                  'itinerary-info.baggageAllowanceNumber'
                    | translate : { size: flight?.baggageAllowance || 0 }
                }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
